<template>
  <div class="main-body">
    <HrLayout @nodeClick="nodeClick">
      <div class="main-body2">
<!--
CREATE TABLE `sp_department_company` (
  `id` int(11) NOT NULL AUTO_INCREMENT COMMENT 'ID',
  `department_id` int(11) DEFAULT NULL COMMENT '部门ID',
  `department_name` varchar(255) DEFAULT NULL COMMENT '部门名称',
  `department_code` varchar(50) DEFAULT NULL COMMENT '部门的NC code',
  `company` varchar(100) DEFAULT NULL COMMENT '公司主体',
  `company_code` varchar(50) DEFAULT NULL COMMENT '公司主体编号',
  `create_time` datetime DEFAULT NULL COMMENT '创建时间',
  `update_time` datetime DEFAULT NULL COMMENT '修改时间',
  PRIMARY KEY (`id`),
  KEY `department_id` (`department_id`),
  KEY `department_name` (`department_name`),
  KEY `company` (`company`),
  KEY `company_code` (`company_code`)
) ENGINE=InnoDB AUTO_INCREMENT=334 DEFAULT CHARSET=utf8 COMMENT='组织架构-法人主体';
-->
        <!-- 查询区域 -->
        <div class="search-box">
          <el-button type="primary" @click="handleAdd" size="mini">新增</el-button>
          <el-input v-model="query.department_name" placeholder="部门名称" style="width:200px" size="mini" />
          <el-input v-model="query.company" placeholder="公司主体" style="width:200px" size="mini" />
          <el-input v-model="query.company_code" placeholder="公司主体编号" style="width:200px" size="mini" />
          <el-button type="primary" @click="getList" size="mini">搜索</el-button>
          <el-button type="primary" @click="exportExcel" size="mini">导出</el-button>
          <el-button type="primary" @click="importExcel" size="mini">导入</el-button>
        </div>

        <!-- 表格 -->
        <el-table :data="pageData.list" border height="70vh">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="department_name" label="部门名称" min-width="320" />
          <el-table-column prop="company" label="公司主体" min-width="200" />
          <el-table-column prop="company_code" label="公司编号" width="100" />
          <el-table-column prop="department_code" label="部门编号" width="130">
            <template slot-scope="scope">
              <input v-model="scope.row.department_code" size="mini" style="width:100px;background-color: #ffe6db;" />
            </template>
          </el-table-column>
<!--          <el-table-column prop="create_time" label="创建时间" />-->
<!--          <el-table-column prop="update_time" label="修改时间" />-->
          <el-table-column label="操作" fixed="right" width="120">
            <template slot-scope="scope">
<!--              <el-button type="primary" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>-->
<!--              <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
              <el-button type="primary" size="mini" @click="submit(scope.row)">保存</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="pageChange"
          @current-change="pageChange"
          :current-page="pageData.page"
          :page-size="pageData.size"
          layout="total, prev, pager, next"
          :total="pageData.total"
          style="margin-top:15px;text-align:right"
        />

        <!-- 新增/编辑弹窗 -->
        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="用户信息">
          <el-descriptions :column="1" border>
            <el-descriptions-item label="公司主体">
<!--              <el-input v-model="form.company" placeholder="输入主体" size="mini" />-->
<!--              <el-select placeholder="请选择主体" v-model="form.company" :remote-method="getCompanyList" remote reserve-keyword filterable style="width:200px">-->
<!--                <el-option v-for="item in company_list" :key="item.id" :label="item.company" :value="item.id"></el-option>-->
<!--              </el-select>-->
              <el-autocomplete
                v-model="form.company"
                :fetch-suggestions="getCompanyList"
                placeholder="请选择主体"
                @select="handleSelect"
                style="width: 300px;"
              ></el-autocomplete>
            </el-descriptions-item>
            <el-descriptions-item label="公司编号">
              <el-input v-model="form.company_code" placeholder="请输入公司编号" size="mini" disabled />
            </el-descriptions-item>
            <el-descriptions-item label="部门名称">
              <el-input v-model="form.department_name" placeholder="输入部门名称" size="mini" />
            </el-descriptions-item>
            <el-descriptions-item label="部门编码">
              <el-input v-model="form.department_code" placeholder="请输入部门编码" size="mini" />
            </el-descriptions-item>


          </el-descriptions>
          <div slot="footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submit()">确认</el-button>
          </div>
        </el-dialog>
      </div>
    </HrLayout>
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'
import HrLayout from "../Common/HrLayout";

export default {
  name: 'DepartmentCompany',
  components: {HrLayout},
  data() {
    return {
      query: {
        department_id:"",
        department_name:"",
        company:"",
        company_code:"",
      },
      pageData:{
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // ====================== 获取列表 ======================
    getList() {
      const params = Params.ins()
        .where(this.query.department_name ? ['department_name', 'like', '%' + this.query.department_name + '%'] : null)
        .where(this.query.company ? ['company', 'like', '%' + this.query.company + '%'] : null)
        .where(this.query.company_code ? ['company_code', '=', this.query.company_code] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('DepartmentCompany/index', params, res => {
        if(res.code===200){
          this.pageData = res.data
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },
    sizeChange(size) {
      this.pageData.size = size
      this.getList()
    },

    nodeClick(data){
      // console.log(data)
      this.query.department_id = data.id
      this.query.department_name = data.ancestor_name
      this.pageChange(1)
    },
    exportExcel(){
      window.open(Http.getBaseURL() + 'DepartmentCompany/exportExcel')
    },
    importExcel(){
      ERP.showLoading();
      Http.upload('DepartmentCompany/importExcel', res => {
        ERP.hideLoading();
        if(res.code===200){
          this.$message.success('导入成功')
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    // 新增
    handleAdd() {
      if(!this.query.department_id){
        this.$message.error({
          message: '请选择部门',
          type: "error",
        });
        return;
      }
      this.form = {
        id: 0,
        department_id: this.query.department_id,
        department_name: this.query.department_name,
        department_code: "",
        company: "",
        company_code: "",
      }
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(id) {
      Http.post('DepartmentCompany/detail', Params.ins().detail(id), res => {
        if(res.code===200){
          this.form = res.data
          this.dialogVisible = true
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    // 提交保存
    submit(item=null) {
      if( item){
        this.form = item
      }
      if (!this.form.id) {
        this.form.id = 0
      }

      Http.post('DepartmentCompany/save', Params.ins().save(this.form), res => {
        if(res.code===200){
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getList()
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    // 删除
    handleDelete(id) {
      const that=this;
      that.$confirm('确定删除？').then( () => {

        Http.post('DepartmentCompany/delete', Params.ins().delete(id), res => {
          if(res.code===200){
            this.$message.success('删除成功')
            this.getList()
          }else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })

      })
    },

    getCompanyList(name, cb) {
      const params = Params.ins()
        .where(name ? ['company', 'like', '%' + name + '%'] : null)
        .order('id desc')
        .page(1)
        .size(50)
        .list()

      Http.post('Company/index', params, res => {
        if(res.code===200){
          // this.company_list = res.data
          cb(res.data.list.map(ret=>{return {label:ret.company, value:ret.company, company_code:ret.company_code}}))
        }else {
          cb([]);
        }
      })
    },
    handleSelect(item){
      this.form.company = item.value
      this.form.company_code = item.company_code
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body{
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/FinancialCenter/DepartmentCompany.vue